import React from "react";
import Select from 'react-select';

// Libs
import {lightPrimaryColor, primaryColor, textColor} from "../libs/theme-lib";

const SelectInput = (props) => {
    const {
        options,
        onChange,
        value,
        placeholder,
        disabled,
        style = {},
        isAdminZone,
        label = "",
        validation = false,
        isValid = true,
        errorMessage = ""
    } = props;

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            minHeight: '42px',
            height: '42px',
            ...isValid ? null : {
                borderColor: "red",
                ...state.isFocused ? {boxShadow: "0 0 0 1px red"} : null,
                "&:hover": {
                    borderColor: "red"
                },
                // "&:focus": {
                //     boxShadow: "0 0 0 1px red"
                // }
            },

        }),
    
        valueContainer: (provided, state) => ({
            ...provided,
            height: '42px',
            padding: '0 6px'
        }),
    
        input: (provided, state) => ({
            ...provided,
            margin: '0px',
        }),
        indicatorSeparator: state => ({
            display: 'none',
        }),
        indicatorsContainer: (provided, state) => ({
            ...provided,
            height: '42px',
        }),

        container: (provided) => ({
            ...provided,
            width: '200px'
        })
    };

    return (
        <div style={{
            ...style
        }}>
            {!!label && <div style={{
                color: "black",
                fontWeight: "bold",
                fontSize: 12,
                marginBottom: 5
            }}>{label}</div>}
            <Select 
                options={options}
                styles={customStyles}
                onChange={onChange}
                value={value}
                placeholder={placeholder}
                isDisabled={disabled}
                theme={theme => ({
                    ...theme,
                    colors: {
                        ...theme.colors,
                        primary: "black",
                        // primary25: "WhiteSmoke"
                        primary25: "#d9d9d9"
                    }
                })}
            />
            {validation && (
                <div style={{
                    color: "red",
                    height: 18,
                    fontSize: 12
                }}>
                    {!isValid && errorMessage}
                </div>
            )}
        </div>
    );
};

export default SelectInput;